export const setStateValue = (type, data) => {
    return {
        type,
        data
    };
};
